<template>
  <div>
    <p
      v-if="!showFeesInput"
      class="tw-cursor-pointer"
      @click="toggleFeesInput"
    >
      + Add Advisory/Management Fees
    </p>
    <div v-else>
      <p
        class="tw-cursor-pointer"
        @click="toggleFeesInput"
      >
        Hide Advisory/Management Fees
      </p>
      <hr class="tw-mt-4">
      <div v-if="checkupStore.portfolio?.name">
        <p class="tw-mt-4 tw-font-bold">
          {{ checkupStore.portfolio.name }} Fees
        </p>
        <div class="tw-mt-2 tw-flex tw-gap-5">
          <o-field
            label="Advisory Fee (%)"
            label-size="small"
            style="margin: 0; flex-grow: 0;"
            label-class="!tw-font-normal"
          >
            <o-input
              v-model="checkupStore.fees.portfolio.advisoryFee"
              step="0.001"
              placeholder="0.05"
              type="number"
              size="small"
              root-class="tw-w-36"
            />
          </o-field>
          <o-field
            label="Management Fee (%)"
            label-size="small"
            style="margin: 0; flex-grow: 0;"
            label-class="!tw-font-normal"
          >
            <o-input
              v-model="checkupStore.fees.portfolio.managementFee"
              step="0.001"
              placeholder="0.05"
              type="number"
              size="small"
              root-class="tw-w-36"
            />
          </o-field>
        </div>
      </div>
      <div v-if="checkupStore.benchmark?.name">
        <p class="tw-mt-4 tw-font-bold">
          {{ checkupStore.benchmark?.name || 'Benchmark' }} Fees
        </p>
        <div class="tw-my-2 tw-flex tw-gap-5">
          <o-field
            label="Advisory Fee (%)"
            label-size="small"
            style="margin: 0; flex-grow: 0;"
            label-class="!tw-font-normal"
          >
            <o-input
              v-model="checkupStore.fees.benchmark.advisoryFee"
              step="0.001"
              placeholder="0.05"
              type="number"
              size="small"
              root-class="tw-w-36"
            />
          </o-field>
          <o-field
            label="Management Fee (%)"
            label-size="small"
            style="margin: 0; flex-grow: 0;"
            label-class="!tw-font-normal"
          >
            <o-input
              v-model="checkupStore.fees.benchmark.managementFee"
              step="0.001"
              placeholder="0.05"
              type="number"
              size="small"
              root-class="tw-w-36"
            />
          </o-field>
        </div>
      </div>
      <div v-if="checkupStore.optimizedPortfolio?.name">
        <p class="tw-mt-4 tw-font-bold">
          {{ checkupStore.optimizedPortfolio?.name || 'Proposed Portfolio' }} Fees
        </p>
        <div class="tw-my-2 tw-flex tw-gap-5">
          <o-field
            label="Advisory Fee (%)"
            label-size="small"
            style="margin: 0; flex-grow: 0;"
            label-class="!tw-font-normal"
          >
            <o-input
              v-model="checkupStore.fees.optimized.advisoryFee"
              step="0.001"
              placeholder="0.05"
              type="number"
              size="small"
              root-class="tw-w-36"
            />
          </o-field>
          <o-field
            label="Management Fee (%)"
            label-size="small"
            style="margin: 0; flex-grow: 0;"
            label-class="!tw-font-normal"
          >
            <o-input
              v-model="checkupStore.fees.optimized.managementFee"
              step="0.001"
              placeholder="0.05"
              type="number"
              size="small"
              root-class="tw-w-36"
            />
          </o-field>
        </div>
      </div>
      <o-button
        variant="primary"
        @click="updateExpenseRatioArea"
      >
        Update Chart
      </o-button>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';
import {
  getExpenseRatio,
} from '@frontend/ui/features/checkup/helpers/checkupFunctions.js';

export default {
  name: 'AdvisorFeeInput',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return {
      showFeesInput: false, /* Local variable to toggle fees input visibility */
    };
  },
  computed: {
    ...mapStores(useCheckupStore, useAdvisorStore),
  },
  methods: {
    async updateExpenseRatioArea() {
      try {
        console.log('ADVISOR STORE', this.advisorStore);
        const { chartData, ...rest } = getExpenseRatio(this.checkupStore.portfolio, this.checkupStore.benchmark, this.checkupStore.optimizedPortfolio, this.checkupStore.fees.portfolio, this.checkupStore.fees.benchmark, this.checkupStore.fees.optimized, this.advisorStore);
        this.checkupStore.updateArea('Fees', {
          name: 'Fees',
          ...rest,
          chartData: [{
            ...chartData,
            type: 'line',
            options: {
              scales: {
                x: {
                  title: { display: true, text: 'Year' },
                },
                y: {
                  title: { display: true, text: 'Cumulative Fees' },
                },
              },
            },
            formats: { y: 'currency' },
          }],
          extraData: [
            ...(this.checkupStore.portfolio ? [
              { name: `${this.checkupStore.portfolio.name || 'Portfolio'} Avg Expense Ratio`, value: (this.checkupStore.portfolio.average_expense_ratio * 100).toFixed(2) + '%' },
              { name: `${this.checkupStore.portfolio.name || 'Portfolio'} Advisory and Mgmt Fees`, value: (rest.portfolioAdditionalFees * 100).toFixed(2) + '%' },
            ] : []),
            ...(this.checkupStore.benchmark ? [
              { name: `${this.checkupStore.benchmark.name || 'Benchmark'} Avg Expense Ratio`, value: (this.checkupStore.benchmark.average_expense_ratio * 100).toFixed(2) + '%' },
              { name: `${this.checkupStore.benchmark.name || 'Benchmark'} Advisory and Mgmt Fees`, value: (rest.benchmarkAdditionalFees * 100).toFixed(2) + '%' },
            ] : []),
            ...(this.checkupStore.optimizedPortfolio ? [
              { name: `${this.checkupStore.optimizedPortfolio.name || 'Optimized'} Avg Expense Ratio`, value: (this.checkupStore.optimizedPortfolio.average_expense_ratio * 100).toFixed(2) + '%' },
              { name: `${this.checkupStore.optimizedPortfolio.name || 'Optimized'} Advisory and Mgmt Fees`, value: (rest.proposedAdditionalFees * 100).toFixed(2) + '%' },
            ] : []),
          ],
          topLeftComponent: {
            component: 'AdvisorFeeInput',
            props: {},
          },
        });
        console.log('CREATE ExpenseRatio DATA', chartData);
        await this.checkupStore.updateAreaExplanationWithFetch('Fees');
      } catch (error) {
        console.error('error', error);
      }
    },
    toggleFeesInput() {
      this.showFeesInput = !this.showFeesInput;
    },
  },
};
</script>


